import request from "root/js/request";

export const getItemsCrossMP = async ({ cabinet_id, cabinet_id__in, marketplace, by, ...rest }) => {
  const response = await request({
    url: "/analytics/cross-mp/mp_items/",
    method: "get",
    params: {
      cabinet_id,
      cabinet_id__in,
      marketplace,
      by,
      ...rest,
    },
  });
  return response.data;
};
